<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YJNgGr/tc-custom/Cover.jpg?1684514922116?1702529295464" alt="This image is the cover for the book Train Crash at Crush, Texas, Disaster"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Train Crash at Crush, Texas, Disaster
      </h1>
      <p class="bookDescription body article font2">
        <p>On September 15, 1896, Crush boasted the highest population in Texas. Built near Waco, the town provided the staging ground for a publicity stunt ramming two trains together at top speed. Showrunner and Katy Railroad official William Crush thought he had planned for every contingency. But when elephant-sized chunks of steam locomotive began raining down into the packed stands, the extravaganza quickly unraveled into one of the Lone Star State's most confounding tragedies. The soon-to-be famous Scott Joplin commemorated the debacle in "The Great Crush Collision March," and entrepreneurs like "Head-On Joe" Connolly of Iowa continued the tradition of the staged locomotive duel for decades. But the stupefying incident still slipped into the back pages of Texas lore. In the first-ever book on the subject, writer-historian Mike Cox finally tells the full story of the Crash at Crush.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Cox
      </h2>
      
      <p class="authorDescription body article">An elected member of the Texas Institute of Letters, Mike Cox is the author of more than thirty nonfiction books. Over an award-winning freelance career dating back to his high school days, he has written hundreds of newspaper articles, columns, magazine stories and essays for a wide variety of regional and national publications. When not writing, he spends as much time as he can traveling, fishing, hunting and looking for new stories to tell. He lives in the Hill Country village of Wimberley, Texas. Weary of traffic jams in his nearby hometown of Austin, he's all for the development of high-speed passenger train service to lure people from their cars and SUVs.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a60b00c